import { render, staticRenderFns } from "./safety-verify.vue?vue&type=template&id=244a12f0&scoped=true"
import script from "./safety-verify.vue?vue&type=script&lang=js"
export * from "./safety-verify.vue?vue&type=script&lang=js"
import style0 from "./safety-verify.vue?vue&type=style&index=0&id=244a12f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a12f0",
  null
  
)

export default component.exports